/** The one-line sentence under the stepper — "60% delivered · 0% invoiced" (BR-SAL-02-03). */
export function ProgressLine({ text }: { text: string }) {
  return <p className="text-sm text-muted-foreground">{text}</p>;
}
